import React from 'react';

const BookIcon: React.FC<{ size?: number; color?: string }> = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4 4.5C4 3.67 4.67 3 5.5 3H15V16.5H5.5C4.67 16.5 4 17.17 4 18V4.5Z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M6.5 5.5H12.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M6.5 8.5H12.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M4 18H15" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export default BookIcon;

